import React, {
    useState,
    useEffect
} from 'react';
import {
    ToggleButton,
    DropdownButton,
    Dropdown,
    Row,
    Col,
    ToggleButtonGroup,
    InputGroup,
    FormControl,
    Alert
} from 'react-bootstrap';
import '../../../styles/MembersTable.css';
import Loading from '../../utility/Loading';
import FilterButton from './FilterButton';
import { HHIERows } from './HHIERows';
import ProvisionNewMembers from '../../provisioning/ProvisionNewMembers';
import ViewMembersAddedToday from '../../provisioning/ViewMembersAddedToday';
import { getSfId } from '../../utility/getSfId';
import { needsChrId } from '../../utility/needsChrId';
import { HHIEButton } from '../../utility/HHIEButton';
import { useRef } from 'react';
import { Legend } from '../individual/Legend';
//import TableStats  from './TableStats';

export const MembersTable = () => {
    const [loading, setLoading] = useState(true);
    const [firstLoad, setFirstLoad] = useState(true);
    const [letter, setLetter] = useState(sessionStorage.getItem("currentLetter") ?? "A");
    const [letterCount, setLetterCount] = useState(0);
    const [members, setMembers] = useState(null);
    const [amountOfPages, setAmountOfPages] = useState(null);
    const [currentPage, setCurrentPage] = useState(parseInt(sessionStorage.getItem("currentPage") ?? 1));
    const [resultSize, setResultSize] = useState(10);
    const [goToLast, setGoToLast] = useState(false);
    const [filtered, setFiltered] = useState(null);
    const [passed, setPassed] = useState(sessionStorage.getItem("passedFilter") === "true");
    const [failed, setFailed] = useState(sessionStorage.getItem("failedFilter") === "true");
    const [active, setActive] = useState(sessionStorage.getItem("activeFilter") === "true");
    const [inactive, setInactive] = useState(sessionStorage.getItem("inactiveFilter") === "true");
    const [onHold, setOnHold] = useState(sessionStorage.getItem("onHoldFilter") === "true");
    const [unassigned, setUnassigned] = useState(sessionStorage.getItem("unassignedFilter") === "true");
    const [needsChr, setNeedsChr] = useState(sessionStorage.getItem("needsChrFilter") === "true");
    const [hasServices, setHasServices] = useState(sessionStorage.getItem("hasServiceFilter") === "true");
    const [noServices, setNoServices] = useState(sessionStorage.getItem("noServiceFilter") === "true");

    const [search, setSearch] = useState(sessionStorage.getItem("searchValue") && sessionStorage.getItem("searchValue") !== "");
    const [searchValue, setSearchValue] = useState(sessionStorage.getItem("searchValue") ?? "");

    const [showLegend, setShowLegend] = useState(false);
    const target = useRef(null);

    useEffect(() => {
        if (!loading && firstLoad) {
            //const searchVal = sessionStorage.getItem("searchValue");
            setFirstLoad(false);
        }
    }, [loading, firstLoad])

    useEffect(() => {
        sessionStorage.setItem('currentLetter', letter);
        sessionStorage.setItem('currentPage', currentPage);
        sessionStorage.setItem('passedFilter', passed);
        sessionStorage.setItem('failedFilter', failed);
        sessionStorage.setItem('activeFilter', active);
        sessionStorage.setItem('inactiveFilter', inactive);
        sessionStorage.setItem('onHoldFilter', onHold);
        sessionStorage.setItem('unassignedFilter', unassigned);
        sessionStorage.setItem('needsChrFilter', needsChr);
        sessionStorage.setItem('hasServiceFilter', hasServices);
        sessionStorage.setItem('noServiceFilter', noServices);
        sessionStorage.setItem('searchValue', searchValue);
        sessionStorage.setItem('resultSize', resultSize);
    }, [letter, currentPage, passed, failed, active, inactive, onHold, unassigned,
        needsChr, hasServices, noServices, search, searchValue])

    // member retrieval UseEffect
    useEffect(() => {
        getMembersByLetter(letter);
        setSearchValue("");
    }, [letter]);

    // filter UseEffect
    useEffect(() => {
        if (filtered) {
            setAmountOfPages(Math.ceil((filtered.length) / resultSize));
            setCurrentPage(firstLoad && currentPage !== null ? currentPage : 1);

        }
    }, [filtered])

    // search UseEffect
    useEffect(() => {
        if (search) {
            var encodedSearch = encodeURIComponent(searchValue);
            var sfid = getSfId();
            fetch('api/Member/getMembers/' + encodedSearch + '/' + sfid)
                .then((response) => {
                    response.json()
                        .then((json) => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors)
                            setMembers(json.message);
                            setLoading(false);
                        })
                        .catch((error) => {
                            if (error.message.contains("Unexpected character <")) {
                                alert("Salesforce connection has timed out.");
                                window.location.href = "/logout";
                            }
                        })
                })
                .catch((error) => {
                    console.log("Response error: " + error);
                });
            setSearch(false);
        }
    }, [search, searchValue]);

    const getMembersByLetter = (letter) => {
        if (!search) {
            setLoading(true);
            var sfid = getSfId();
            fetch('api/member/getCountByLastNameLetter/' + letter + '/' + sfid)
                .then(response => {
                    response.json().then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        setLetterCount(json.message);
                    })
                }
                ).catch(error => {
                    console.log(error);
                    console.log("Couldnt get a response with count");
                });
            fetch('api/member/getMembersWithLetter/' + letter + '/' + sfid)
                .then((response) => {
                    response.json()
                        .then((retrievedMembers) => {
                            if (retrievedMembers.errors !== null && retrievedMembers.errors !== "") alert(retrievedMembers.errors)
                            setMembers(retrievedMembers.message);
                            // Divide total_items by limit, and round the value up.
                            setLoading(false);
                            let filteredMembers = filterMembers(retrievedMembers.message);
                            setAmountOfPages(Math.ceil((filteredMembers.length) / resultSize));

                            if (goToLast) {
                                setGoToLast(false);
                                setCurrentPage(Math.ceil((filteredMembers.length) / resultSize));
                            }
                            else {
                                setCurrentPage(firstLoad && currentPage !== null ? currentPage : 1);
                            }
                        })
                        .catch((error) => {
                            console.log("retrieved members error: " + error);
                        })
                })
                .catch((error) => {
                    console.log("Error getting a response: " + error);
                });
        }
    }

    const filterMembers = (members) => {
        // get values from state variables to safely use them
        let displayPassedMembers = passed;
        let displayFailedMembers = failed;
        let displayActiveMembers = active;
        let displayInactiveMembers = inactive;
        let displayOnHoldMembers = onHold;
        let displayUnassignedMembers = unassigned;
        let displayNeedsChrMembers = needsChr;
        let displayHasServicesMembers = hasServices;
        let displayNoServicesMembers = noServices;

        let filteredMembers = members.filter(member => {
            if (displayNeedsChrMembers && !needsChrId(member)) {
                return false;
            }
            // OnHold is checked, and member is not on hold, 
            // return false right away, else do nothing and 
            // continue to filter
            if (displayOnHoldMembers && !member.passStatus.onHold) {
                return false;
            }

            if (displayUnassignedMembers && member.account.legalName !== "Unassigned") {
                return false;
            }
            if (displayHasServicesMembers && !CheckForServices(member)) {
                return false;
            }
            if (displayNoServicesMembers && CheckForServices(member)) {
                return false;
            }

            var desiredOverallProvision = 'Both';
            if (displayPassedMembers) { desiredOverallProvision = 'PASS'; }
            else if (displayFailedMembers) { desiredOverallProvision = 'FAIL'; }

            var desiredStatus = 'Both';
            if (displayActiveMembers) { desiredStatus = 'Active'; }
            else if (displayInactiveMembers) { desiredStatus = 'Inactive'; }
            // Nothing is checked, except possibly OnHold, 
            // but members who are not OnHold have been 
            // filtered OUT already
            // x x x x      
            if (desiredStatus === 'Both' && desiredOverallProvision === 'Both') {
                return true;
            }
            if (desiredStatus === 'Both') {
                if (member.passStatus.overallPassed === desiredOverallProvision) {
                    return true;
                } else {
                    return false;
                }
            }
            if (desiredOverallProvision === 'Both') {
                if (member.status === desiredStatus) {
                    return true;
                } else {
                    return false;
                }
            }
            if (member.status === desiredStatus && member.passStatus.overallPassed === desiredOverallProvision) {
                return true;
            }


            return false;
        });
        if (filtered == null || filtered.length !== filteredMembers.length) {
            setFiltered(filteredMembers);
            setAmountOfPages(Math.ceil((filteredMembers.length) / resultSize))
        }


        // slice list based on page size and current page
        return filteredMembers;
    }

    const CheckForServices = (member) => {
        if (member.chr || member.notify || member.dsm || member.referrals) {
            return true;
        }
        else return false;
    }

    const renderTable = () => {
        let page = parseInt(currentPage);
        let size = parseInt(resultSize);
        let startposition = parseInt((page - 1) * size);
        let endpositon = parseInt(((page - 1) * size) + size);

        let slicedMemberList = filterMembers(members).slice(startposition, endpositon);
        return (<HHIERows members={slicedMemberList} id="all-members-table" />)
    }

    const alphRadios = [
        { name: "A" }, { name: "B" }, { name: "C" }, { name: "D" }, { name: "E" }, { name: "F" }, { name: "G" }, { name: "H" }, { name: "I" }, { name: "J" }, { name: "K" }, { name: "L" }, { name: "M" }, { name: "N" }, { name: "O" }, { name: "P" }, { name: "Q" }, { name: "R" }, { name: "S" }, { name: "T" }, { name: "U" }, { name: "V" }, { name: "W" }, { name: "X" }, { name: "Y" }, { name: "Z" }, { name: "num" }
    ];
    const limitDrops = [{ name: "10" }, { name: "20" }, { name: "40" }, { name: "60" }, { name: "80" }, { name: "100" }]

    const handleFirstClick = () => {
        setCurrentPage(1);// goes to first page of letter results
    };
    const handleLastClick = () => {
        setCurrentPage(amountOfPages);// this only goes to last page of current letter of records
    };

    const handleNextClick = () => {
        // if page is already the last page do nothing
        if (currentPage === amountOfPages && letter === "num") {
        }
        else if (currentPage === amountOfPages || amountOfPages < 1) {
            let index = alphRadios.findIndex(alphletter => {
                if (alphletter.name === letter) {
                    return true;
                }
                return false;
            });
            setLetter(alphRadios[index + 1].name);
        }
        else {
            setCurrentPage(currentPage + 1);
        }
    };
    // PREV SHOULD GO BACK A LETTER TO THE LAST PAGE
    const handlePrevClick = () => {
        // if page is already the first page do nothing
        if (currentPage === 1 && letter === "A") {
        }
        else if (currentPage === 1) {
            setGoToLast(true);
            let index = alphRadios.findIndex(alphletter => {
                if (alphletter.name === letter) {
                    return true;
                }
                return false;
            });
            setLetter(alphRadios[index - 1].name);
            // set page to last page, but if letter is changed,
            // then useEffect func gets called, how do we know when to change to page last instead of page(1)?
            // this gets overwritten by function -> setCurrentPage(amountOfPages);
        }
        else {
            setCurrentPage(currentPage - 1);
        }
    };
    const handleAlphClick = (e) => {
        setLetter(e);
        setCurrentPage(1);
    };
    const handleResultSizeChange = (e) => {
        setResultSize(e);
        setAmountOfPages(Math.ceil((filtered.length) / e));
        setCurrentPage(1);
    };
    const handleSearchClick = () => {
        //searchCheck();
        //setOffset("0");
        setSearch(true);
        setLoading(true);
    };
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearchClick();
        }
    };

    // BEGIN RENDER LOGIC
    return (
            <div className="entire-table">
                {loading && <Loading message={<div>Loading. . . please wait</div>} />}
                {!loading && members &&
                    <>
                        <div style={{
                            marginTop: '5px'
                            , marginBottom: '7px'
                            // ,textAlign: 'center'
                        }}>
                            <ProvisionNewMembers />

                            <ViewMembersAddedToday />
                        </div>
                        <Alert variant='info'>
                            {letterCount > 4000 &&
                                <Row>
                                    <div style={{ color: 'red', fontSize: '15px' }}><strong>WARNING:</strong> Letter {letter} has over 4000 records, only the first 4000 are being displayed.</div>
                        </Row>}
                    <Legend target={target} showLegend={showLegend}/>
                        <Row className="d-flex justify-content-center" ref={target} onMouseEnter={() => { setShowLegend(true) }} onMouseLeave={() => {setShowLegend(false)}}>
                                <FilterButton
                                    id="passed-filter-btn"
                                    disabled={failed}
                                    name={'Passed'}
                                    defaultChecked={passed}
                                    onChange={() => { setPassed(!passed); }}
                                />
                                <FilterButton
                                    id="failed-filter-btn"
                                    disabled={passed}
                                    name={'Failed'}
                                    defaultChecked={failed}
                                    onChange={() => { setFailed(!failed); }}
                                />
                                <FilterButton
                                    id="active-filter-btn"
                                    disabled={inactive}
                                    name={'Active'}
                                    defaultChecked={active}
                                    onChange={() => { setActive(!active); }}
                                />
                                <FilterButton
                                    id="inactive-filter-btn"
                                    disabled={active}
                                    name={'Inactive'}
                                    defaultChecked={inactive}
                                    onChange={() => { setInactive(!inactive); }}
                                />
                                <FilterButton
                                    id="on-hold-filter-btn"
                                    name={'On Hold'}
                                    defaultChecked={onHold}
                                    onChange={() => { setOnHold(!onHold); }}
                                />
                                <FilterButton
                                    id="unassigned-filter-btn"
                                    name={'Unassigned'}
                                    defaultChecked={unassigned}
                                    onChange={() => { setUnassigned(!unassigned); }}
                                />
                                <FilterButton
                                    id="needs-chr-filter-btn"
                                    name={'Needs Chr Id'}
                                    defaultChecked={needsChr}
                                    onChange={() => { setNeedsChr(!needsChr); }}
                                />
                                <FilterButton
                                    id="has-services-btn"
                                    name={'Has Services'}
                                    disabled={noServices}
                                    defaultChecked={hasServices}
                                    onChange={() => { setHasServices(!hasServices); }}
                                />
                                <FilterButton
                                    id="no-services-btn"
                                    name={'Doesn\'t Have Services'}
                                    disabled={hasServices}
                                    defaultChecked={noServices}
                                    onChange={() => { setNoServices(!noServices); }}
                                />
                        </Row>
                            <hr />
                            <Row>
                                <Col></Col>
                                <Col className="style-search d-flex justify-content-center" md={8} lg={8}>
                                    <InputGroup class-name="mb-3">
                                        <FormControl
                                            id="member-name=search"
                                            placeholder="Member's Name"
                                            aria-label="Member's Name"
                                            aria-describedby="member-name-search"
                                            style={{ borderRadius: '10px', marginRight: '4px' }}
                                            defaultValue={searchValue}
                                            onChange={(e) => { setSearchValue(e.target.value) }}
                                            onKeyPress={(e) => { handleKeyPress(e) }}
                                        />
                                        <HHIEButton
                                            variant="primary"
                                            size="sm"
                                            id="search-button"
                                            onClick={handleSearchClick}
                                            title="Search"
                                        />
                                    </InputGroup>
                                </Col>
                                <Col></Col>
                            </Row>
                            <hr />
                            <Row className="table-buttons-group" lg="auto">
                                <HHIEButton
                                    id="first-btn"
                                    className="table-button"
                                    variant="primary"
                                    size="sm"
                                    value="first"
                                    onClick={handleFirstClick}
                                    title="First"
                                />
                                <HHIEButton
                                    id="last-btn"
                                    className="table-button"
                                    variant="primary"
                                    size="sm"
                                    onClick={handleLastClick}
                                    title="Last"
                                />
                                <ToggleButtonGroup
                                    id="letters-btns"
                                    className="table-button"
                                    toggle
                                    name="letters"
                                    size="sm"
                                    onChange={handleAlphClick}
                                >
                                    {alphRadios.map(
                                        (radio, index) => (
                                            <ToggleButton
                                                variant="light"
                                                key={index}
                                                type="radio"
                                                name="alphRadio"
                                                value={radio.name}
                                                checked={letter === radio.name}
                                            >
                                                {(radio.name === "num") ? "0-9" : radio.name}
                                            </ToggleButton>
                                        )
                                    )}
                                </ToggleButtonGroup>
                                <HHIEButton
                                    id="prev-btn"
                                    className="table-button"
                                    variant="primary"
                                    size="sm"
                                    onClick={handlePrevClick}
                                    title="Previous"
                                />
                                <HHIEButton
                                    id="next-btn"
                                    className="table-button"
                                    variant="primary"
                                    size="sm"
                                    onClick={handleNextClick}
                                    title="Next"
                                />
                                <DropdownButton
                                    className="table-button"
                                    id="dropdown-limit-button"
                                    size="sm"
                                    title={resultSize + " results"}
                                    variant="primary"
                                    style={{ borderRadius: '10px', fontSize: '16px' }}
                                >
                                    {limitDrops.map((lim, index) => (
                                        <Dropdown.Item
                                            id={index + "-limit-btn"}
                                            key={index}
                                            eventKey={lim.name}
                                            type="radio"
                                            value={lim.name}
                                            active={resultSize.toString() === lim.name}
                                            onSelect={handleResultSizeChange}
                                        >
                                            {lim.name}
                                        </Dropdown.Item>
                                    ))}
                                </DropdownButton>
                            </Row>
                        </Alert>
                        <Row>
                            {(searchValue && searchValue !== "") ?
                                <Col id="records-info" className="record-stats">
                                    {/* If lettercount is greater than 4000, show a warning somehow, use an overlay tooltip? */}
                                    Showing {filtered ? filtered.length : ""} records matching "{searchValue}"
                                </Col>
                                :
                                <Col id="records-info" className="record-stats">
                                    {/* If lettercount is greater than 4000, show a warning somehow, use an overlay tooltip? */}
                                    Showing {filtered ? filtered.length : ""} out of {letterCount} [<strong>{letter}</strong>] records by last name initial
                                </Col>
                            }
                            {/* <Col>
                <strong>{letter}</strong>'s have {letterCount} records out of {contactCount} total records
            </Col> */}
                            <div id="pg-number-tracker" className="page-number-tracker">
                                Page {currentPage} of {amountOfPages}
                            </div>
                        </Row>
                        {renderTable()}
                    </>
                }
            </div>
    );
}